import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'singleLetterUpper'})
export class SingleLetterUpper implements PipeTransform {
  transform(value: string, before: string, after: string): string {
    if (!value && value[0]) {
        return value;
    } else {
        return value[0].toUpperCase() + value.substr(1).toLowerCase();
    }
  }
}
